import React, { useState, useEffect } from "react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { Icon } from "tabler-react";

/**
 * HistorialMovimiento
 * Muestra el historial de cambios (bitácora) de un movimiento específico.
 * Props:
 *  - idMovimiento: ID del movimiento a consultar
 *  - cerrarModal: función para cerrar el modal (inyectada por ModalLay)
 */
const HistorialMovimiento = ({ idMovimiento, cerrarModal }) => {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idMovimiento) {
      setCargando(false);
      setError("No se proporcionó un ID de movimiento.");
      return;
    }
    Crud_Catalogos(
      "usuariosLog/idmovimiento/" + idMovimiento + "/plataformatipo/1",
      "",
      "get",
      "",
      [],
      "",
      "",
      "",
      []
    )
      .then((data) => {
        if (Array.isArray(data)) {
          setRegistros(data);
        } else {
          setRegistros([]);
        }
        setCargando(false);
      })
      .catch((err) => {
        console.error("Error al consultar historial:", err);
        setError("Error al cargar el historial.");
        setCargando(false);
      });
  }, []);

  if (cargando) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Icon name="loader" /> Cargando historial...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        {error}
      </div>
    );
  }

  if (registros.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
        No hay registros de historial para este movimiento.
      </div>
    );
  }

  return (
    <div style={{ padding: "10px", maxHeight: "500px", overflowY: "auto" }}>
      <table className="table table-striped table-hover table-sm">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Usuario</th>
            <th>Acción</th>
            <th>Descripción</th>
          </tr>
        </thead>
        <tbody>
          {registros.map((reg, idx) => (
            <tr key={reg.id || idx}>
              <td style={{ whiteSpace: "nowrap" }}>{reg.accionFecha || ""}</td>
              <td>{reg.idUsuario || ""}</td>
              <td>{reg.idBitacoraMonitoreo || ""}</td>
              <td>{reg.descripcion || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistorialMovimiento;
